import React, { useState } from "react";

/** Shared inline date/time picker for "Reschedule Interview" (immediate change) and
 * "Propose New Time" (applicant must confirm the new time) - both hit the same 2-hour
 * protected-block conflict check server-side (interview_scheduling_service._reserve_new_slot),
 * this form just decides which endpoint to call. */
export const InterviewRescheduleForm = ({ booking, mode, onSubmit, onCancel }) => {
  const [date, setDate] = useState(booking.date || "");
  const [startTime, setStartTime] = useState(booking.start_time || "10:00");
  const [submitting, setSubmitting] = useState(false);

  const label = mode === "PROPOSE" ? "Send Proposed Time" : "Confirm New Time";
  const testPrefix = mode === "PROPOSE" ? "propose-time" : "reschedule-interview";

  const handleSubmit = async () => {
    if (!date || !startTime) return;
    setSubmitting(true);
    try {
      await onSubmit(date, startTime);
    } catch (e) {
      // Error is already surfaced via toast by the page-level action helper - keep the
      // form open so the recruiter can adjust and retry.
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-2 bg-gray-50 rounded-lg border border-gray-200 p-3" data-testid={`${testPrefix}-form`}>
      <div className="flex gap-2">
        <input
          data-testid={`${testPrefix}-date-input`}
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="flex-1 px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm"
        />
        <input
          data-testid={`${testPrefix}-time-input`}
          type="time"
          step={1800}
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
          className="flex-1 px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm"
        />
      </div>
      <div className="flex gap-2">
        <button
          data-testid={`${testPrefix}-submit`}
          disabled={!date || !startTime || submitting}
          onClick={handleSubmit}
          className="flex-1 px-3 py-1.5 rounded-full bg-blue-950 text-white text-xs font-semibold hover:bg-blue-900 disabled:opacity-50"
        >
          {submitting ? "Saving..." : label}
        </button>
        <button data-testid={`${testPrefix}-cancel`} onClick={onCancel} className="px-3 py-1.5 rounded-full border border-gray-300 text-xs font-semibold hover:bg-gray-100">
          Cancel
        </button>
      </div>
    </div>
  );
};
